import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ title, value, icon, color = 'blue' }) => {
  const colorClasses = {
    blue: 'bg-primary-subtle text-primary',
    green: 'bg-success-subtle text-success',
    yellow: 'bg-warning-subtle text-warning',
    purple: 'bg-accent-subtle text-accent',
    red: 'bg-error-subtle text-error'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <p className="text-3xl font-bold text-foreground">{value}</p>
        </div>
        <div className={`p-3 rounded-lg ${colorClasses?.[color] || colorClasses?.blue}`}>
          <Icon name={icon} size={24} />
        </div>
      </div>
    </div>
  );
};

export default StatCard;